import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
const HeaderContext = createContext(undefined);
export const HeaderProvider = ({ children }) => {
    const [isPrime, setIsPrime] = useState(false);
    return _jsx(HeaderContext.Provider, { value: { isPrime, setIsPrime }, children: children });
};
export const useHeader = () => {
    const context = useContext(HeaderContext);
    if (context === undefined) {
        throw new Error('useHeader must be used within a HeaderProvider');
    }
    return context;
};
